export class Disposable {
    constructor() {
        this._disposes = [];
        this.disposed = false;
        this.dispose = () => {
            this.disposed = true;
            this._disposes.forEach((dispose) => dispose());
            this._disposes = [];
        };
        this.addDispose = (dispose) => {
            this._disposes.push(dispose);
        };
    }
}
//# sourceMappingURL=Disposable.js.map